import { forwardRef } from 'react';

import { BoxGridProps } from './type';
import StyledBoxGrid from './styled';

const BoxGrid = forwardRef<HTMLDivElement, BoxGridProps>(({ children, ...props }, ref) => {
  return (
    <StyledBoxGrid ref={ref} {...props}>
      {children}
    </StyledBoxGrid>
  );
});

export default BoxGrid;
